$('#datatable-resale-listings').dataTable({
  order: [[2, "desc"], [1, "asc"]],
  "pageLength": 50
});
